import i18n from 'i18next'
import enTranslation from './locales/en/translation.json'
import trTranslation from './locales/tr/translation.json'
import ruTranslation from './locales/ru/translation.json'

export const SUPPORTED_LANGUAGES = [
  { code: 'tr', name: 'Türkçe' },
  { code: 'en', name: 'English' },
  { code: 'ru', name: 'Русский' }
]

const detectInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return 'tr'
  }

  const stored = window.localStorage.getItem('i18nextLng')
  if (stored && SUPPORTED_LANGUAGES.find((lang) => lang.code === stored)) {
    return stored
  }

  const hostname = window.location.hostname
  if (hostname.startsWith('eu-')) return 'en'
  if (hostname.startsWith('tr-')) return 'tr'
  if (hostname.startsWith('ru-')) return 'ru'

  const browserLang = navigator.language?.slice(0, 2)
  if (browserLang && SUPPORTED_LANGUAGES.find((lang) => lang.code === browserLang)) {
    return browserLang
  }

  return 'tr'
}

i18n.init({
  resources: {
    tr: { translation: trTranslation },
    en: { translation: enTranslation },
    ru: { translation: ruTranslation }
  },
  lng: detectInitialLanguage(),
  fallbackLng: 'tr',
  supportedLngs: SUPPORTED_LANGUAGES.map((lang) => lang.code),
  interpolation: {
    escapeValue: false
  }
})

i18n.on('languageChanged', (lng) => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem('i18nextLng', lng)
  } catch {
    // ignore storage write failures
  }
})

export default i18n
